<template>
  <v-menu v-if="user && user.name" offset-y origin="right top" left content-class="language-dropdown" transition="slide-y-transition" nudge-top="-10">
    <template v-slot:activator="{ on }">
      <v-btn icon large v-on="on" class="user-block-wrap ml-3 d-none">
        <img src="avatar.png" alt="avatar" height="40" width="40" class="rounded-circle" />
      </v-btn>
    </template>
    <div class="dropdown-content">
      <div class="dropdown-top white--text primary">
        <span class="white--text fs-14 fw-bold d-block">{{ user.name }}</span>
        <span class="d-block fs-12 fw-normal">{{ user.email }}</span>
      </div>
      <v-list class="dropdown-list">
        <template v-for="userLink in userLinks">
          <template v-if="userLink.id !== 4">
            <v-list-item :to="{ name: userLink.path }" :key="userLink.id">
              <i :class="userLink.icon"></i>
              <span>{{ $t(userLink.title) }}</span>
            </v-list-item>
          </template>
          <template v-else>
            <v-list-item @click="logoutUser" :key="userLink.id">
              <i :class="userLink.icon"></i>
              <span>{{ $t(userLink.title) }}</span>
            </v-list-item>
          </template>
        </template>
      </v-list>
    </div>
  </v-menu>
</template>
<script>
import { getCurrentAppLayout } from 'Helpers/helpers'

export default {
  computed: {
    user: function () {
      return this.$store.getters.getUser
    },
    isAdmin: function () {
      return this.$store.getters.userType == 'admin'
    }
  },
  data() {
    return {
      userLinks: [
        {
          id: 1,
          title: 'Edit Profile',
          icon: 'ti-user mr-3 primary--text',
          path: 'profileSettings'
        },
        {
          id: 4,
          title: 'Log Out',
          icon: 'ti-power-off mr-3 error--text'
        }
      ]
    }
  },
  methods: {
    logoutUser() {
      this.$store.dispatch('logoutUser', this.$router)
    },
    getMenuLink(path) {
      // return '/' + getCurrentAppLayout(this.$router) +  path;
    }
  }
}
</script>
